"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpeningState = void 0;
/**
 * This enum describes the state of the progress of a student regarding an
 * activity or objective. Unopened means the activity/objective is inaccessible,
 * opened that it is accessible, and closed that it is finished.
 */
var OpeningState;
(function (OpeningState) {
    OpeningState[OpeningState["Unopened"] = 0] = "Unopened";
    OpeningState[OpeningState["Opened"] = 1] = "Opened";
    OpeningState[OpeningState["Closed"] = 2] = "Closed";
})(OpeningState = exports.OpeningState || (exports.OpeningState = {}));
